import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import trCommon from "./locales/common.tr.json";
import enCommon from "./locales/common.en.json";
import trSbom from "./locales/sbom.tr.json";
import enSbom from "./locales/sbom.en.json";
import trEdges from "./locales/edges.tr.json";
import enEdges from "./locales/edges.en.json";
import trEdgeDetail from "./locales/edgeDetail.tr.json";
import enEdgeDetail from "./locales/edgeDetail.en.json";
import trHome from "./locales/home.tr.json";
import enHome from "./locales/home.en.json";
import trAlarms from "./locales/alarms.tr.json";
import enAlarms from "./locales/alarms.en.json";
import trMarketplace from "./locales/marketplace.tr.json";
import enMarketplace from "./locales/marketplace.en.json";
import trVpn from "./locales/vpn.tr.json";
import enVpn from "./locales/vpn.en.json";
import trAuth from "./locales/auth.tr.json";
import enAuth from "./locales/auth.en.json";
import trProfile from "./locales/profile.tr.json";
import enProfile from "./locales/profile.en.json";
import trNav from "./locales/nav.tr.json";
import enNav from "./locales/nav.en.json";
import trAdmin from "./locales/admin.tr.json";
import enAdmin from "./locales/admin.en.json";

// Her ekran ailesi kendi dosyasında (<alan>.tr.json / <alan>.en.json, üst anahtar = alan adı) çevrilir ve tek bir
// "translation" namespace'i altında birleştirilir; paralel çalışan ajanlar aynı JSON'u ezmesin diye.
// Yeni alan: iki import satırı + aşağıdaki iki spread. Ayrıntı: docs/i18n.md
const tr = { ...trCommon, ...trSbom, ...trEdges, ...trEdgeDetail, ...trHome, ...trAlarms, ...trMarketplace, ...trVpn, ...trAuth, ...trProfile, ...trNav, ...trAdmin };
const en = { ...enCommon, ...enSbom, ...enEdges, ...enEdgeDetail, ...enHome, ...enAlarms, ...enMarketplace, ...enVpn, ...enAuth, ...enProfile, ...enNav, ...enAdmin };

export const STORAGE_KEY = "vx_lang";
export const LANGUAGES = ["tr", "en"];

function storedLanguage() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return LANGUAGES.includes(v) ? v : null;
  } catch {
    return null; // localStorage yoksa / engelliyse varsayılan dil
  }
}

const initial = storedLanguage() || "tr";

i18n.use(initReactI18next).init({
  resources: { tr: { translation: tr }, en: { translation: en } },
  lng: initial,
  fallbackLng: "tr",
  interpolation: { escapeValue: false },
});
if (typeof document !== "undefined") document.documentElement.lang = initial;

export function setLanguage(lang) {
  if (!LANGUAGES.includes(lang)) return;
  i18n.changeLanguage(lang);
  if (typeof document !== "undefined") document.documentElement.lang = lang;
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    // tercih yalnızca bu oturum için geçerli kalır
  }
}

export default i18n;
